import { Flex, Modal } from 'antd';
import { FillButton } from 'components/elements';

/**
 * 
 * @returns 
 */
export const ConfirmModal = ({ open, title = '', width, footer, confirmLabel='확인', canelLabel='닫기', confirmColor='var(--color-gray03)', onConfirm, onCancel, children }) => {
  
  const onHandleConfirm = () => {
    if (onConfirm) onConfirm();
  }
  const onHandleCancel = () => {
    if (onCancel) onCancel();
  }
  return (
    <Modal
      open={open}
      title={title}
      closable={false}
      centered={true}
      width={width || '400px'}
      styles={{
        header: {
          padding: '1rem 0',
          borderBottom: '1px solid var(--color-gray08)'
        },
        body: {
          margin: '3rem 0'
        },
        footer: {
          marginBottom: '2rem'
        }
      }}
      footer={footer || [
        <Flex justify="center" gap={'small'}>
          <FillButton label={confirmLabel} backgroundColor={confirmColor} onClick={onHandleConfirm} />
          <FillButton label={canelLabel} color={'var(--color-gray03)'} backgroundColor={'var(--color-gray04)'} onClick={onHandleCancel} />
        </Flex>
      ]}
    >
      {children}
    </Modal>
  );
};
